import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
} from '@angular/core';
import { NgMaterialModule } from '@principle-theorem/ng-material';

@Component({
  selector: 'pr-icon-chip',
  templateUrl: './icon-chip.component.html',
  styleUrls: ['./icon-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NgMaterialModule],
  host: {
    class: 'inline-block select-none rounded p-0.5',
  },
})
export class IconChipComponent {
  icon = input<string>('question_mark');
  iconOnly = input(false, {
    transform: coerceBooleanProperty,
  });
  iconClass = input<string>('');
  fontSet = input<undefined | 'material-symbols'>(undefined);
  noBorder = input<boolean>(false);

  @HostBinding('class')
  get hostClass(): string {
    return this.noBorder() ? '' : 'border border-solid border-slate-300';
  }
}
